import type { FC } from "react";

import { Card, CardRowSimple, type GridCard } from "widgets";
import { formatNumberByThousands } from "widgets/utils";

import { ContigTile, GenomeViewTile, ProteinTile } from "../../core/tiles/index.js";
import { type AaFeature } from "@/graphql.js";

export interface IAaFeatureCardProps extends GridCard {
  aaFeature: AaFeature;
}

const AaFeatureCard: FC<IAaFeatureCardProps> = ({ aaFeature }) => {
  if (!aaFeature) {
    return null;
  }

  return (
    <Card key="marker-info-card" title={"Amino Acid Feature Info"}>
      <CardRowSimple label={"Type"}>{aaFeature.aaFeatureType.name}</CardRowSimple>
      <CardRowSimple label={"Name"}>{aaFeature.name}</CardRowSimple>
      <CardRowSimple label={"Description"}>{aaFeature.description}</CardRowSimple>
      <CardRowSimple label={"p-value"}>{aaFeature.pValue}</CardRowSimple>
      <CardRowSimple label={"Score"}>{aaFeature.score}</CardRowSimple>
      <CardRowSimple label={"Protein"}>
        <ProteinTile protein={aaFeature.protein} />
      </CardRowSimple>
      {aaFeature.region && (
        <CardRowSimple label={"Contig"}>
          <ContigTile contig={aaFeature.region?.contig} />
        </CardRowSimple>
      )}
      {aaFeature.region && (
        <CardRowSimple label={"Range"}>
          <GenomeViewTile
            title={`${formatNumberByThousands(aaFeature.region?.range.start)} – ${formatNumberByThousands(
              aaFeature.region?.range.stop,
            )} (${aaFeature.region?.strand})`}
            to={aaFeature.genome.id !== 0 ? `/aaFeature/${aaFeature.id}/genome` : undefined} // Range is not mandatory and the GenomeView of an entity is automatically set./>
            tooltip={
              aaFeature.genome.id === 0
                ? "Genome view is not available because this feature does not belong to a specific genome."
                : undefined
            }
          >
            {formatNumberByThousands(aaFeature.region?.range.stop - aaFeature.region?.range.start + 1)} bp
          </GenomeViewTile>
        </CardRowSimple>
      )}
    </Card>
  );
};

export { AaFeatureCard };
